module.exports = __webpack_public_path__ + "static/media/windsurfing_1920.82cb8c32.jpg";